import React, { memo } from 'react';
import { bool, func, object, string } from 'prop-types';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
function FormInput({ label, required = false, type = 'text', ...rest }) {
  const { isInvalid = false } = rest;
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <FormControl type={type} {...rest} />
      {isInvalid && <Form.Text className={'text-danger'}>This field is required</Form.Text>}
      {/* <FormControl.Feedback type="invalid">{''}</FormControl.Feedback> */}
    </FormGroup>
  );
}

FormInput.propTypes = {
  label: string.isRequired,
  required: bool,
  type: string,
};

export default FormInput;
